import {
  Accessibility,
  AccountBalance,
  AccountBalanceWallet,
  AccountCircle,
  Assignment,
  Backup,
  CardGiftcard,
  Category,
  ChromeReaderMode,
  Class,
  Compare,
  CreditCard,
  DashboardOutlined,
  Error,
  Fastfood,
  History,
  FolderOpenOutlined,
  Gavel,
  ImportExport,
  List,
  MenuBook,
  Receipt,
  ReceiptOutlined,
  Schedule,
  SettingsApplicationsOutlined,
  ShoppingCartOutlined,
  ShowChart,
  Stars,
  StoreMallDirectory,
  SupervisorAccount,
  Warning, BugReportTwoTone, AccountTree,
} from '@material-ui/icons';
import {
  CONTACT_SALES, ESORDER_URL,
  FRESHDESK_URL,
  HOME_URL,
  KNOWLEDGE_PORTAL_URL, PERIODIC_REPORT,
  SALES_OVERVIEW_REPORT,
  SETTINGS_BACKUP,
  SETTINGS_INVOICES, SWEDISH_IRS,
  TOP_SALES_PER_CATEGORY_REPORT,
  TOP_SALES_PER_PRODUCT_REPORT,
  TRANSACTIONS_URL,
  Z_REPORTS,
} from '../../../const/routes';
import LanguageSelect from '../LanguageSelect';
import React from 'react';
import DarkModeSwitch from '../DarkModeSwitch';
import {
  CASH_GUARD_TRANSACTION_LOG,
  DISCOUNT_PER_EMPLOYEE_REPORT,
  DISCOUNT_PER_TYPE,
  EHK_SALES_OVERVIEW,
  EMPLOYEE_LOGGED_IN_LOG,
  EMPLOYEE_LOGGED_IN_PER_DAY_LOG,
  EMPLOYEE_LOGGED_IN_PER_MONTH_LOG,
  EMPLOYEE_TIME_WORKED,
  EMPLOYEE_WORK_TIME_CORRECTED_LOGS,
  GIFT_CARD_BALANCE_CHANGE_LOG,
  GIFT_CARD_BALANCE_PER_DATE,
  GIFT_CARD_TRANSACTION_LOG,
  INVALID_REGISTRATIONS_LOG,
  INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE,
  INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY,
  INVENTORY_ITEM_STOCK_CHANGES_LIST,
  PAYMENTS_PER_DAY,
  PAYMENTS_PER_DAY_AND_EMPLOYEE,
  PAYMENTS_TOTAL,
  PAYOUT_PER_CATEGORY,
  PAYOUT_PER_PRODUCT,
  SALES_AND_PAYMENTS_PER_CATEGORY,
  SALES_PER_CAMPAIGN,
  SALES_PER_CATEGORY,
  SALES_PER_CATEGORY_AND_CUSTOMER,
  SALES_PER_CATEGORY_AND_EMPLOYEE,
  SALES_PER_DATE,
  SALES_PER_PRODUCT,
  SALES_PER_PRODUCT_AND_EMPLOYEE,
  SALES_PER_SUPPLIER,
  SALES_PER_SUPPLIER_AND_PRODUCT,
  TRANSACTION_LIST,
  TRANSACTION_LIST_SIE_Z_REPORT_LIST,
  WASTE_REGISTRATIONS_LOG,
  WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE,
  WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY,
} from '../../pages/reports/standard/StandardReportConfig';
import {
  ADMINISTRATION_ACCOUNTS,
  ADMINISTRATION_ARTICLES, ADMINISTRATION_BOOKEEPING,
  ADMINISTRATION_CATEGORIES,
  ADMINISTRATION_CUSTOMERS,
  ADMINISTRATION_DICTIONARIES,
  ADMINISTRATION_SUBCATEGORIES,
  ADMINISTRATION_VOUCHERS,
  ADMINISTRATION_WORKING,
} from '../../pages/administration/AdministrationPagesConfig';
import { FormattedMessage } from 'react-intl';
import { SALES_COMPARISONS } from '../../pages/reports/comparisons/ComparisionReportConfig';
import Integrations from '../../pages/integrations/Integrations';
import V1Application from '../V1Link';
import ProLicenseUpgrade from '../ProLicenseUpgrade';
import { CustomFreshDeskIcon } from '../../../assets/CustomFreshdeskIcon';
import { ReactComponent as EsKassa } from '../../../../src/assets/eskassa_small.svg';

export const BASIC_LICENSE = 'Basic';
export const PRO_LICENSE = 'Pro';

export const MainMenuConfig = [
  {
    labelId: 'menu.main.overview',
    label: 'Overview',
    icon: DashboardOutlined,
    link: HOME_URL,
    serverName: 'Dashboard',
  },
  {
    labelId: 'menu.main.reports',
    label: 'Reports',
    icon: FolderOpenOutlined,
    submenu: [
      {
        label: <FormattedMessage
          id="menu.main.reports.sales-overview"
          defaultMessage="Sales overview"
        />,
        icon: Gavel,
        link: SALES_OVERVIEW_REPORT,
        serverName: 'SalesOverviewReport',
      },
      {
        labelId: 'menu.main.reports.top',
        label: 'Top Sales',
        icon: List,
        submenu: [
          {
            label: <FormattedMessage
              id="menu.main.reports.top.category-sales"
              defaultMessage="Top sales per category"
            />,
            icon: Category,
            link: TOP_SALES_PER_CATEGORY_REPORT,
            serverName: 'TopSalesPerCategory',
          },
          {
            label: <FormattedMessage
              id="menu.main.reports.top.product-sales"
              defaultMessage="Top sales per product"
            />,
            icon: Fastfood,
            link: TOP_SALES_PER_PRODUCT_REPORT,
            serverName: 'TopSalesPerProduct',
          },
        ],
      },
      {
        labelId: 'menu.main.reports.z',
        label: 'Z-report',
        icon: Assignment,
        link: Z_REPORTS,
        serverName: 'ZReports',
      },
      {
        labelId: 'menu.main.reports.periodic',
        label: 'Periodic report',
        subLabel: 'inclusive X-reports',
        icon: History,
        link: PERIODIC_REPORT,
        serverName: 'PeriodicReport',
      },
      {
        icon: ImportExport,
        label: TRANSACTION_LIST_SIE_Z_REPORT_LIST.reportTitle,
        link: TRANSACTION_LIST_SIE_Z_REPORT_LIST.urlPath,
        serverName: TRANSACTION_LIST_SIE_Z_REPORT_LIST.serverName,
      },
      {
        labelId: 'menu.main.reports.other.sales',
        label: 'Sales',
        icon: ShowChart,
        submenu: [
          {
            label: TRANSACTION_LIST.reportTitle,
            link: TRANSACTION_LIST.urlPath,
            serverName: TRANSACTION_LIST.serverName,
          },
          {
            label: EHK_SALES_OVERVIEW.reportTitle,
            link: EHK_SALES_OVERVIEW.urlPath,
            disabledOnMobile: true,
            serverName: EHK_SALES_OVERVIEW.serverName,
          },
          {
            label: SALES_AND_PAYMENTS_PER_CATEGORY.reportTitle,
            link: SALES_AND_PAYMENTS_PER_CATEGORY.urlPath,
            serverName: SALES_AND_PAYMENTS_PER_CATEGORY.serverName,
          },
          {
            label: SALES_PER_DATE.reportTitle,
            link: SALES_PER_DATE.urlPath,
            serverName: SALES_PER_DATE.serverName,
          },
          {
            label: SALES_PER_CAMPAIGN.reportTitle,
            link: SALES_PER_CAMPAIGN.urlPath,
            serverName: SALES_PER_CAMPAIGN.serverName,
          },
          {
            label: SALES_PER_CATEGORY.reportTitle,
            link: SALES_PER_CATEGORY.urlPath,
            serverName: SALES_PER_CATEGORY.serverName,
          },
          {
            label: SALES_PER_CATEGORY_AND_EMPLOYEE.reportTitle,
            link: SALES_PER_CATEGORY_AND_EMPLOYEE.urlPath,
            serverName: SALES_PER_CATEGORY_AND_EMPLOYEE.serverName,
          },
          {
            label: SALES_PER_CATEGORY_AND_CUSTOMER.reportTitle,
            link: SALES_PER_CATEGORY_AND_CUSTOMER.urlPath,
            serverName: SALES_PER_CATEGORY_AND_CUSTOMER.serverName,
          },
          {
            label: SALES_PER_SUPPLIER.reportTitle,
            link: SALES_PER_SUPPLIER.urlPath,
            serverName: SALES_PER_SUPPLIER.serverName,
          },
          {
            label: SALES_PER_SUPPLIER_AND_PRODUCT.reportTitle,
            link: SALES_PER_SUPPLIER_AND_PRODUCT.urlPath,
            serverName: SALES_PER_SUPPLIER_AND_PRODUCT.serverName,
          },
          {
            label: SALES_PER_PRODUCT.reportTitle,
            link: SALES_PER_PRODUCT.urlPath,
            serverName: SALES_PER_PRODUCT.serverName,
          },
          {
            label: SALES_PER_PRODUCT_AND_EMPLOYEE.reportTitle,
            link: SALES_PER_PRODUCT_AND_EMPLOYEE.urlPath,
            serverName: SALES_PER_PRODUCT_AND_EMPLOYEE.serverName,
          },
        ],
      },
      {
        labelId: 'menu.main.reports.comparisons',
        label: 'Sales Comparisons',
        link: SALES_COMPARISONS.urlPath,
        icon: Compare,
        serverName: SALES_COMPARISONS.serverName,
      },
      {
        labelId: 'menu.main.reports.other.payouts',
        label: 'Payout',
        icon: AccountBalanceWallet,
        submenu: [
          {
            label: PAYOUT_PER_PRODUCT.reportTitle,
            link: PAYOUT_PER_PRODUCT.urlPath,
            serverName: PAYOUT_PER_PRODUCT.serverName,
          },
          {
            label: PAYOUT_PER_CATEGORY.reportTitle,
            link: PAYOUT_PER_CATEGORY.urlPath,
            serverName: PAYOUT_PER_CATEGORY.serverName,
          },
        ],
      },
      {
        labelId: 'menu.main.reports.other.payments',
        label: 'Payments',
        icon: AccountBalance,
        submenu: [
          {
            label: PAYMENTS_PER_DAY.reportTitle,
            link: PAYMENTS_PER_DAY.urlPath,
            serverName: PAYMENTS_PER_DAY.serverName,
          },
          {
            label: PAYMENTS_PER_DAY_AND_EMPLOYEE.reportTitle,
            link: PAYMENTS_PER_DAY_AND_EMPLOYEE.urlPath,
            serverName: PAYMENTS_PER_DAY_AND_EMPLOYEE.serverName,
          },
          {
            label: PAYMENTS_TOTAL.reportTitle,
            link: PAYMENTS_TOTAL.urlPath,
            serverName: PAYMENTS_TOTAL.serverName,
          },
        ],
      },
      {
        labelId: 'menu.main.reports.other.discounts',
        label: 'Discounts',
        icon: Stars,
        submenu: [
          {
            label: DISCOUNT_PER_EMPLOYEE_REPORT.reportTitle,
            link: DISCOUNT_PER_EMPLOYEE_REPORT.urlPath,
            serverName: DISCOUNT_PER_EMPLOYEE_REPORT.serverName,
          },
          {
            label: DISCOUNT_PER_TYPE.reportTitle,
            link: DISCOUNT_PER_TYPE.urlPath,
            serverName: DISCOUNT_PER_TYPE.serverName,
          },
        ],
      },
      {
        labelId: 'menu.main.reports.other.giftcard',
        label: 'Giftcard',
        icon: CardGiftcard,
        submenu: [
          {
            label: GIFT_CARD_TRANSACTION_LOG.reportTitle,
            link: GIFT_CARD_TRANSACTION_LOG.urlPath,
            serverName: GIFT_CARD_TRANSACTION_LOG.serverName,
          },
          {
            label: GIFT_CARD_BALANCE_CHANGE_LOG.reportTitle,
            link: GIFT_CARD_BALANCE_CHANGE_LOG.urlPath,
            serverName: GIFT_CARD_BALANCE_CHANGE_LOG.serverName,
          },
          {
            label: GIFT_CARD_BALANCE_PER_DATE.reportTitle,
            link: GIFT_CARD_BALANCE_PER_DATE.urlPath,
            serverName: GIFT_CARD_BALANCE_PER_DATE.serverName,
          },
        ],
      },
      {
        labelId: 'menu.main.reports.other.errors',
        label: 'Errors',
        icon: Error,
        submenu: [
          {
            label: INVALID_REGISTRATIONS_LOG.reportTitle,
            link: INVALID_REGISTRATIONS_LOG.urlPath,
            serverName: INVALID_REGISTRATIONS_LOG.serverName,
          },
          {
            label: INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE.reportTitle,
            link: INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE.urlPath,
            serverName: INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE.serverName,
          },
          {
            label: INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY.reportTitle,
            link: INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY.urlPath,
            serverName: INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY.serverName,
          },
        ],
      },
      {
        labelId: 'menu.main.reports.other.staff',
        label: 'Staff',
        icon: AccountCircle,
        submenu: [
          {
            label: EMPLOYEE_TIME_WORKED.reportTitle,
            link: EMPLOYEE_TIME_WORKED.urlPath,
            serverName: EMPLOYEE_TIME_WORKED.serverName,
          },
          {
            label: EMPLOYEE_LOGGED_IN_PER_DAY_LOG.reportTitle,
            link: EMPLOYEE_LOGGED_IN_PER_DAY_LOG.urlPath,
            serverName: EMPLOYEE_LOGGED_IN_PER_DAY_LOG.serverName,
          },
          {
            label: EMPLOYEE_LOGGED_IN_PER_MONTH_LOG.reportTitle,
            link: EMPLOYEE_LOGGED_IN_PER_MONTH_LOG.urlPath,
            serverName: EMPLOYEE_LOGGED_IN_PER_MONTH_LOG.serverName,
          },
          {
            label: EMPLOYEE_LOGGED_IN_LOG.reportTitle,
            link: EMPLOYEE_LOGGED_IN_LOG.urlPath,
            serverName: EMPLOYEE_LOGGED_IN_LOG.serverName,
          },
          {
            label: EMPLOYEE_WORK_TIME_CORRECTED_LOGS.reportTitle,
            link: EMPLOYEE_WORK_TIME_CORRECTED_LOGS.urlPath,
            serverName: EMPLOYEE_WORK_TIME_CORRECTED_LOGS.serverName,
          },
        ],
      },
      {
        labelId: 'menu.main.reports.other.waste',
        label: 'Waste',
        icon: Warning,
        submenu: [
          {
            label: WASTE_REGISTRATIONS_LOG.reportTitle,
            link: WASTE_REGISTRATIONS_LOG.urlPath,
            serverName: WASTE_REGISTRATIONS_LOG.serverName,
          },
          {
            label: WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE.reportTitle,
            link: WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE.urlPath,
            serverName: WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE.serverName,
          },
          {
            label: WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY.reportTitle,
            link: WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY.urlPath,
            serverName: WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY.serverName,
          },
        ],
      },
      {
        label: CASH_GUARD_TRANSACTION_LOG.reportTitle,
        icon: CreditCard,
        link: CASH_GUARD_TRANSACTION_LOG.urlPath,
        serverName: CASH_GUARD_TRANSACTION_LOG.serverName,
      },
      {
        label: INVENTORY_ITEM_STOCK_CHANGES_LIST.reportTitle,
        icon: StoreMallDirectory,
        link: INVENTORY_ITEM_STOCK_CHANGES_LIST.urlPath,
        serverName: INVENTORY_ITEM_STOCK_CHANGES_LIST.serverName,
      },
    ],
  },
  {
    labelId: 'menu.main.transactions',
    label: 'Transactions',
    icon: ShoppingCartOutlined,
    link: TRANSACTIONS_URL,
    serverName: 'Transactions',
  },
  {
    labelId: 'menu.main.administration',
    label: 'Administration',
    icon: ReceiptOutlined,
    submenu: [
      {
        label: ADMINISTRATION_WORKING.title,
        icon: Schedule,
        link: ADMINISTRATION_WORKING.urlPath,
        serverName: ADMINISTRATION_WORKING.serverName,
      },
      {
        label: ADMINISTRATION_ACCOUNTS.title,
        icon: SupervisorAccount,
        link: ADMINISTRATION_ACCOUNTS.urlPath,
        serverName: ADMINISTRATION_ACCOUNTS.serverName,
      },
      {
        label: ADMINISTRATION_CUSTOMERS.title,
        icon: Accessibility,
        link: ADMINISTRATION_CUSTOMERS.urlPath,
        serverName: ADMINISTRATION_CUSTOMERS.serverName,
      },
      {
        label: ADMINISTRATION_VOUCHERS.title,
        icon: CardGiftcard,
        link: ADMINISTRATION_VOUCHERS.urlPath,
        serverName: ADMINISTRATION_VOUCHERS.serverName,
      },
      {
        label: ADMINISTRATION_ARTICLES.title,
        icon: Fastfood,
        link: ADMINISTRATION_ARTICLES.urlPath,
        serverName: ADMINISTRATION_ARTICLES.serverName,
      },
      {
        label: ADMINISTRATION_CATEGORIES.title,
        icon: Category,
        link: ADMINISTRATION_CATEGORIES.urlPath,
        serverName: ADMINISTRATION_CATEGORIES.serverName,
      },
      {
        label: ADMINISTRATION_SUBCATEGORIES.title,
        icon: Class,
        link: ADMINISTRATION_SUBCATEGORIES.urlPath,
        serverName: ADMINISTRATION_SUBCATEGORIES.serverName,
      },
      {
        label: ADMINISTRATION_DICTIONARIES.title,
        icon: ChromeReaderMode,
        link: ADMINISTRATION_DICTIONARIES.urlPath,
        serverName: ADMINISTRATION_DICTIONARIES.serverName,
      },
      {
        label: ADMINISTRATION_BOOKEEPING.title,
        icon: AccountTree,
        link: ADMINISTRATION_BOOKEEPING.urlPath,
      },
    ],
  },
  {
    labelId: 'menu.main.settings',
    label: 'Settings',
    icon: SettingsApplicationsOutlined,
    submenu: [
      {
        labelId: 'menu.main.settings.backup',
        label: 'Backup',
        icon: Backup,
        link: SETTINGS_BACKUP,
        disabled: true,
      },
      {
        labelId: 'menu.main.settings.invoices',
        label: 'Invoices',
        icon: Receipt,
        link: SETTINGS_INVOICES,
        serverName: 'SettingsInvoices',
      },
      {
        object: <Integrations />,
        serverName: 'SettingsIntegrations',
        available: [PRO_LICENSE],
      },
    ],
  },
  {
    labelId: 'menu.main.knowledge-portal',
    label: 'Knowledge Portal',
    icon: MenuBook,
    link: KNOWLEDGE_PORTAL_URL,
  },
  {
    labelId: 'menu.main.contact.sales',
    label: 'Contact sales',
    icon: BugReportTwoTone,
    link: CONTACT_SALES,
  },
  {
    object: <V1Application />,
    available: [BASIC_LICENSE, PRO_LICENSE],
  },
  {
    labelId: 'menu.main.swedish-irs',
    label: 'Skatteverket',
    icon: AccountBalance,
    link: SWEDISH_IRS,
  },
  {
    object: <ProLicenseUpgrade />,
    available: [BASIC_LICENSE],
  },
  {
    labelId: 'menu.main.freshdesk',
    label: 'Customer support',
    icon: CustomFreshDeskIcon,
    submenu: [
      {
        labelId: 'create.new.ticket',
        label: 'Create ticket',
        icon: CustomFreshDeskIcon,
        link: `${FRESHDESK_URL}/create`,
      },
      {
        labelId: 'your.tickets',
        label: 'My tickets',
        icon: CustomFreshDeskIcon,
        link: `${FRESHDESK_URL}/tickets`,
      },
    ],
  },
  {
    labelId: 'menu.main.esorder',
    label: 'ES Order Backoffice',
    icon: EsKassa,
    link: ESORDER_URL,
  },
  {
    object: <DarkModeSwitch />,
    available: [BASIC_LICENSE, PRO_LICENSE],
  },
  {
    object: <LanguageSelect />,
    available: [BASIC_LICENSE, PRO_LICENSE],
  },
];

//available:    hiding / showing navigation item
//serverName: enabling / disabling navigation item by API